const autoNgTemplateLoaderTemplate1 = require('./template.html');

angular.module('portainer.registrymanagement').component('progressionModal', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  bindings: {
    resolve: '<',
  },
});
